<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <BaseLink
          class="ui-link-secondary typography__body2"
          :href="`/${locale}`"
        >
          <span v-html="t('pages.faq.index.backToMainSite')" />
        </BaseLink>

        <h1
          class="typography__headline1"
          v-html="t('pages.faq.index.header.title')"
        />

        <p v-html="t('pages.faq.index.header.description')" />
      </div>

      <FaqSearch />
    </div>

    <div
      v-if="computedPopularArticles !== null"
      class="page__block"
    >
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.index.sections.popularArticles')"
      />

      <ul class="page__list">
        <li
          v-for="article in computedPopularArticles"
          :key="article.slug"
        >
          <FaqCardArticlePopular :article />
        </li>
      </ul>
    </div>

    <div
      v-if="faqCategoryList !== null"
      class="page__block"
    >
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.index.sections.topicalAnswers')"
      />

      <ul class="page__list">
        <li
          v-for="category in faqCategoryList"
          :key="category.slug"
        >
          <FaqCardArticleCategory :category />
        </li>
      </ul>
    </div>
  </section>
</template>

<script lang="ts" setup>
const { t, locale } = useI18n();
const { list: faqCategoryList } = await useGetFaqCategoryListApi();

const computedPopularArticles = computed(() => {
  if (faqCategoryList.value === null) {
    return null;
  }

  return faqCategoryList.value.reduce<FaqArticleWithCategory[]>((articles, category) => {
    for (const categoryArticle of category.articles) {
      if (categoryArticle.popular === true) {
        articles.push({
          ...categoryArticle,
          category: {
            name: category.name,
            slug: category.slug,
          },
        });
      }
    }

    return articles;
  }, []);
});

useSeoMeta({
  title: t("pages.faq.index.seo.title"),
});

definePageMeta({
  layout: "faq",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 60px;
}

@media (--md) {
  .page {
    row-gap: 80px;
  }
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  align-items: start;
  row-gap: 8px;
}

.page__block {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

@media (--md) {
  .page__list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (--xl) {
  .page__list {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>
